import BankingVideoModal from './BankingVideoModal';

export default BankingVideoModal;
